import { getI18n } from 'react-i18next';
import { getUIPhase } from '../../utils/AuctionPhase';

export const VALIDATION_AUCTION_EMPTY_NAME = 'validation.auction.emptyName';
export const VALIDATION_AUCTION_NAME_ALREADY_USED = 'validation.auction.nameAlreadyInUse';
export const VALIDATION_AUCTION_IMMUTABLE_NAME = 'validation.auction.immutableName';
export const VALIDATION_AUCTION_INVALID_NAME_LENGTH = 'validation.auction.invalidNameLength';
export const VALIDATION_AUCTION_EMPTY_QUANTITY = 'validation.auction.emptyQuantity';
export const VALIDATION_AUCTION_INVALID_QUANTITY = 'validation.auction.invalidQuantity';
export const VALIDATION_AUCTION_IMMUTABLE_QUANTITY = 'validation.auction.immutableQuantity';
export const VALIDATION_AUCTION_EMPTY_OPENING_TIME = 'validation.auction.emptyOpeningTime';
export const VALIDATION_AUCTION_OPENING_TIME_IN_PAST = 'validation.auction.openingTimeInPast';
export const VALIDATION_AUCTION_IMMUTABLE_OPENING_TIME = 'validation.auction.immutableOpeningTime';
export const VALIDATION_AUCTION_EMPTY_CLOSURE_TIME = 'validation.auction.emptyClosureTime';
export const VALIDATION_AUCTION_IMMUTABLE_CLOSURE_TIME = 'validation.auction.immutableClosureTime';
export const VALIDATION_AUCTION_OPENING_AFTER_CLOSURE = 'validation.auction.openingTimeAfterClosureTime';
export const VALIDATION_AUCTION_EMPTY_POWER = 'validation.auction.emptyPower';
export const VALIDATION_AUCTION_NOT_NULL_POWER = 'validation.auction.notNullPower';
export const VALIDATION_AUCTION_IMMUTABLE_POWER = 'validation.auction.immutablePower';
export const VALIDATION_AUCTION_EMPTY_DELIVERY_YEAR = 'validation.auction.emptyDeliveryYear';
export const VALIDATION_AUCTION_DELIVERY_IN_PAST = 'validation.auction.deliveryYearInPast';
export const VALIDATION_AUCTION_NOT_NULL_DELIVERY_YEAR = 'validation.auction.notNullDeliveryYear';
export const VALIDATION_AUCTION_IMMUTABLE_DELIVERY_YEAR = 'validation.auction.immutableDeliveryYear';
export const VALIDATION_AUCTION_PRODUCT_NOT_FOUND = 'validation.auction.productNotExist';
export const VALIDATION_AUCTION_PRODUCT_NOT_ACTIVE = 'validation.auction.productNotActive';
export const VALIDATION_AUCTION_IMMUTABLE_PRODUCT = 'validation.auction.immutableProduct';
export const VALIDATION_AUCTION_INVALID_DESCRIPTION_LENGTH = 'validation.auction.invalidDescriptionLength';
export const VALIDATION_AUCTION_IMMUTABLE_DESCRIPTION = 'validation.auction.immutableDescription';
export const VALIDATION_AUCTION_CANNOT_CHANGE_PHASE = 'validation.auction.cannot.change.phase';
export const VALIDATION_AUCTION_PUBLISH_CLOSURE_TIME_NOT_IN_PAST = 'validation.publish.closureDate.notInPast';
export const VALIDATION_AUCTION_NOT_NULL_SHOW_LAST_PRICE = 'validation.auction.notNullShowLastPrice';
export const VALIDATION_AUCTION_EMPTY_SHOW_LAST_PRICE = 'validation.auction.emptyShowLastPrice';
export const VALIDATION_AUCTION_IMMUTABLE_SHOW_LAST_PRICE = 'validation.auction.immutableShowLastPrice';
export const VALIDATION_AUCTION_NOT_NULL_SHOW_RANKING = 'validation.auction.notNullShowRanking';
export const VALIDATION_AUCTION_EMPTY_SHOW_RANKING = 'validation.auction.emptyShowRanking';
export const VALIDATION_AUCTION_IMMUTABLE_SHOW_RANKING = 'validation.auction.immutableShowRanking';
export const VALIDATION_AUCTION_NOT_NULL_LIMIT_BID_MODIFICATION = 'validation.auction.notNullLimitBidModification';
export const VALIDATION_AUCTION_EMPTY_LIMIT_BID_MODIFICATION = 'validation.auction.emptyLimitBidModification';
export const VALIDATION_AUCTION_IMMUTABLE_LIMIT_BID_MODIFICATION = 'validation.auction.immutableLimitBidModification';
export const VALIDATION_AUCTION_IMMUTABLE_MAX_PRICE = 'validation.auction.immutableMaxPrice';
export const VALIDATION_AUCTION_IMMUTABLE_MIN_PRICE = 'validation.auction.immutableMinPrice';
export const VALIDATION_AUCTION_EMPTY_ZONE = 'validation.auction.emptyZone';
export const VALIDATION_AUCTION_INVALID_ZONE = 'validation.auction.invalidZone';
export const VALIDATION_AUCTION_IMMUTABLE_ZONE = 'validation.auction.immutableZone';
export const VALIDATION_AUCTION_EMPTY_AUCTIONEER = 'validation.auction.emptyAuctioneer';
export const VALIDATION_AUCTION_INVALID_AUCTIONEER = 'validation.auction.invalidAuctioneer';
export const VALIDATION_AUCTION_IMMUTABLE_AUCTIONEER = 'validation.auction.immutableAuctioneer';
export const VALIDATION_AUCTION_EMPTY_ALGORITHM = 'validation.auction.emptyAuctionAlgorithm';
export const VALIDATION_AUCTION_INVALID_ALGORITHM = 'validation.auction.invalidAuctionAlgorithm';
export const VALIDATION_AUCTION_IMMUTABLE_ALGORITHM = 'validation.auction.immutableAuctionAlgorithm';
export const VALIDATION_AUCTION_EMPTY_SMALLEST_UNIT = 'validation.auction.emptySmallestUnit';
export const VALIDATION_AUCTION_NOT_NULL_SMALLEST_UNIT = 'validation.auction.notNullSmallestUnit';
export const VALIDATION_AUCTION_INVALID_SMALLEST_UNIT = 'validation.auction.invalidSmallestUnit';
export const VALIDATION_AUCTION_IMMUTABLE_SMALLEST_UNIT = 'validation.auction.immutableSmallestUnit';
export const VALIDATION_AUCTION_EMPTY_SETTL_START_TYPE = 'validation.auction.emptySettlStartType';
export const VALIDATION_AUCTION_NOT_NULL_SETTL_START_TYPE = 'validation.auction.notNullSettlStartType';
export const VALIDATION_AUCTION_IMMUTABLE_SETTL_START_TYPE = 'validation.auction.immutableSettlStartType';
export const VALIDATION_AUCTION_NOT_NULL_MAX_BID_SIZE = 'validation.auction.notNullMaxBidSize';
export const VALIDATION_AUCTION_INVALID_MAX_BID_SIZE = 'validation.auction.invalidMaxBidSize';
export const VALIDATION_AUCTION_IMMUTABLE_MAX_BID_SIZE = 'validation.auction.immutableMaxBidSize';
export const VALIDATION_AUCTION_NOT_NULL_FAST_MARKET = 'validation.auction.notNullFastMarket';
export const VALIDATION_AUCTION_EMPTY_FAST_MARKET = 'validation.auction.emptyFastMarket';
export const VALIDATION_AUCTION_IMMUTABLE_FAST_MARKET = 'validation.auction.immutableFastMarket';
export const VALIDATION_AUCTION_EMPTY_BIDDING_TYPE = 'validation.auction.emptyBiddingType';
export const VALIDATION_AUCTION_INVALID_BIDDING_TYPE = 'validation.auction.invalidBiddingType';
export const VALIDATION_AUCTION_IMMUTABLE_BIDDING_TYPE = 'validation.auction.immutableBiddingType';
export const VALIDATION_AUCTION_EMPTY_AUCTION_ACCEPTANCE_TYPE = 'validation.auction.emptyAuctionAcceptanceType';
export const VALIDATION_AUCTION_INVALID_AUCTION_ACCEPTANCE_TYPE = 'validation.auction.invalidAuctionAcceptanceType';
export const VALIDATION_AUCTION_IMMUTABLE_AUCTION_ACCEPTANCE_TYPE = 'validation.auction.immutableAuctionAcceptanceType';
export const VALIDATION_AUCTION_EMPTY_TRADE_PRICE_CALCULATION_TYPE = 'validation.auction.emptyTradePriceCalculationType';
export const VALIDATION_AUCTION_INVALID_TRADE_PRICE_CALCULATION_TYPE = 'validation.auction.invalidTradePriceCalculationType';
export const VALIDATION_AUCTION_IMMUTABLE_TRADE_PRICE_CALCULATION_TYPE = 'validation.auction.immutableTradePriceCalculationType';
export const VALIDATION_AUCTION_EMPTY_AUCTION_TYPE = 'validation.auction.emptyAuctionType';
export const VALIDATION_AUCTION_INVALID_AUCTION_TYPE = 'validation.auction.invalidAuctionType';
export const VALIDATION_AUCTION_IMMUTABLE_AUCTION_TYPE = 'validation.auction.immutableAuctionType';
export const VALIDATION_AUCTION_NOT_NULL_AUCTIONEER_DATA_ITEMS = 'validation.auction.notNullAuctioneerDataItems';
export const VALIDATION_AUCTION_EMPTY_AUCTIONEER_DATA_ITEMS = 'validation.auction.emptyAuctioneerDataItems';
export const VALIDATION_AUCTION_AUCTIONEER_DATA_QUANTITY_SUM_NOT_EQUAL_AUCTION_QUANTITY = 'validation.auction.auctioneerData.quantitySumNotEqualAuctionQuantity';
export const VALIDATION_AUCTION_DEVIATION_LIMIT_MISSING = 'validation.auction.deviationLimitMissing';
export const VALIDATION_AUCTION_RELATIVE_DEVIATION_TOO_LOW = 'validation.auction.relativeDeviationTooLow';
export const VALIDATION_AUCTION_RELATIVE_DEVIATION_TOO_HIGH = 'validation.auction.relativeDeviationTooHigh';
export const VALIDATION_AUCTION_QUANTITY_NOT_REACHED = 'validation.auction.quantityNotReached';
export const VALIDATION_AUCTION_REOPEN_INVALID_CLOSURE_TIME = 'validation.auction.reopen.invalidClosureTime';
export const VALIDATION_AUCTION_INVALID_MAX_BID_SIZE_SMALLEST_UNIT_COMBINATION = 'validation.auction.invalidMaxBidSizeSmallestUnitCombination';
export const VALIDATION_AUCTION_INVALID_MIN_MAX_PRICE_COMBINATION = 'validation.auction.invalidMinMaxPriceCombination';
export const VALIDATION_ENERGY_PER_LOT_INVALID_YEAR = 'validation.calculateEnergyPerLot.invalidYear';
export const VALIDATION_ENERGY_PER_LOT_INVALID_POWER = 'validation.calculateEnergyPerLot.invalidPower';
export const VALIDATION_ENERGY_PER_LOT_PRODUCT_NOT_ACTIVE = 'validation.calculateEnergyPerLot.productNotActive';
export const VALIDATION_ENERGY_PER_LOT_PRODUCT_NOT_FOUND = 'validation.calculateEnergyPerLot.productNotExist';
export const VALIDATION_AUCTION_NOT_FOUND = 'validation.auction.notFound';
export const VALIDATION_AUCTION_INVALID_PHASE = 'validation.auction.invalidPhase';
export const VALIDATION_AUCTION_CLOSING_SOON = 'validation.auction.closingSoon';
export const VALIDATION_AUCTION_CLOSING = 'validation.auction.closing';
export const VALIDATION_AUCTION_REVENUE_SPLIT_TOO_LOW = 'validation.auction.revenueSplitTooLow';
export const VALIDATION_AUCTION_REVENUE_SPLIT_TOO_HIGH = 'validation.auction.revenueSplitTooHigh';
export const VALIDATION_AUCTION_EMPTY_REVENUE_SPLIT = 'validation.auction.emptyRevenueSplit';
export const ERROR_AUCTION_NOT_FOUND = 'auction.notFound';
export const ERROR_AUCTION_UPDATE_NOT_ALLOWED = 'auction.update.notAllowed';
export const ERROR_AUCTION_INVALID_SORT_KEY = 'auction.sort.invalidField';
export const ERROR_AUCTION_DISTRIBUTE_NOT_DISTRIBUTABLE_PHASE = 'auction.distribute.notDistributablePhase';
export const ERROR_AUCTION_DISTRIBUTE_ALREADY_DISTRIBUTED = 'auction.distribute.alreadyDistributed';
export const ERROR_AUCTION_DISTRIBUTE_WRONG_ZONE = 'auction.distribute.wrongZone';
export const ERROR_AUCTION_DISTRIBUTE_WRONG_PRODUCT = 'auction.distribute.wrongProduct';
export const ERROR_AUCTION_DISTRIBUTE_WRONG_AUCTION_TYPE = 'auction.distribute.wrongAuctionType';
export const ERROR_AUCTION_DISTRIBUTE_NOT_UPCOMING = 'auction.distribute.notUpcoming';
export const ERROR_AUCTION_DISTRIBUTE_INVALID_STEP = 'auction.distribute.invalidStep';
export const ERROR_AUCTION_DISTRIBUTE_NO_DISTRIBUTIONS = 'auction.distribute.noDistributions';
export const ERROR_AUCTION_DISTRIBUTE_DUPLICATE_AUCTION = 'auction.distribute.duplicateAuction';
export const ERROR_AUCTION_DISTRIBUTE_INVALID_AUCTIONEER_STEP = 'auction.distribute.invalidAuctioneerStep';
export const ERROR_AUCTION_DISTRIBUTE_AUCTIONEER_SUM_MISMATCH = 'auction.distribute.auctioneerSumMismatch';
export const ERROR_AUCTION_DISTRIBUTE_AUCTIONEER_DATA_MISMATCH = 'auction.distribute.auctioneerDataMismatch';
export const ERROR_AUCTION_DISTRIBUTE_SOURCE_INDIVISIBLE = 'auction.distribute.sourceIndivisible';
export const ERROR_AUCTION_DISTRIBUTE_TOTAL_MISMATCH = 'auction.distribute.totalMismatch';
export const ERROR_AUCTION_DISTRIBUTE_AUCTIONEER_ALLOCATION_MISMATCH = 'auction.distribute.auctioneerAllocationMismatch';

export const createAuctionErrorMessage = (code, params) => { // NOSONAR javascript:S3800
    let result;
    const i18n = getI18n();
    switch (code) { // NOSONAR javascript:S1479
        case VALIDATION_AUCTION_EMPTY_NAME:
            result = i18n.t('auctions.error.auction-name-empty');
            break;
        case VALIDATION_AUCTION_NAME_ALREADY_USED:
            result = i18n.t('auctions.error.auction-name-already-used');
            break;
        case VALIDATION_AUCTION_IMMUTABLE_NAME:
            result = i18n.t('auctions.error.auction-name-immutable');
            break;
        case VALIDATION_AUCTION_INVALID_NAME_LENGTH:
            result = i18n.t('auctions.error.auction-name-invalid-length', { maxLetters: parseInt(params[0], 10) });
            break;
        case VALIDATION_AUCTION_EMPTY_QUANTITY:
            result = i18n.t('auctions.error.auction-quantity-empty');
            break;
        case VALIDATION_AUCTION_INVALID_QUANTITY:
            result = i18n.t('auctions.error.auction-quantity-invalid');
            break;
        case VALIDATION_AUCTION_IMMUTABLE_QUANTITY:
            result = i18n.t('auctions.error.auction-quantity-immutable');
            break;
        case VALIDATION_AUCTION_EMPTY_OPENING_TIME:
            result = i18n.t('auctions.error.auction-opening-time-empty');
            break;
        case VALIDATION_AUCTION_OPENING_TIME_IN_PAST:
            result = i18n.t('auctions.error.auction-opening-time-in-past');
            break;
        case VALIDATION_AUCTION_IMMUTABLE_OPENING_TIME:
            result = i18n.t('auctions.error.auction-opening-time-immutable');
            break;
        case VALIDATION_AUCTION_EMPTY_CLOSURE_TIME:
            result = i18n.t('auctions.error.auction-closing-time-empty');
            break;
        case VALIDATION_AUCTION_IMMUTABLE_CLOSURE_TIME:
            result = i18n.t('auctions.error.auction-closing-time-immutable');
            break;
        case VALIDATION_AUCTION_OPENING_AFTER_CLOSURE:
            result = i18n.t('auctions.error.auction-opening-after-closure');
            break;
        case VALIDATION_AUCTION_EMPTY_POWER:
            result = i18n.t('auctions.error.auction-power-empty');
            break;
        case VALIDATION_AUCTION_NOT_NULL_POWER:
            result = i18n.t('auctions.error.auction-power-not-null');
            break;
        case VALIDATION_AUCTION_IMMUTABLE_POWER:
            result = i18n.t('auctions.error.auction-power-immutable');
            break;
        case VALIDATION_AUCTION_EMPTY_DELIVERY_YEAR:
            result = i18n.t('auctions.error.auction-delivery-year-empty');
            break;
        case VALIDATION_AUCTION_DELIVERY_IN_PAST:
            result = i18n.t('auctions.error.auction-delivery-year-in-past');
            break;
        case VALIDATION_AUCTION_NOT_NULL_DELIVERY_YEAR:
            result = i18n.t('auctions.error.auction-delivery-year-not-null');
            break;
        case VALIDATION_AUCTION_IMMUTABLE_DELIVERY_YEAR:
            result = i18n.t('auctions.error.auction-delivery-year-immutable');
            break;
        case VALIDATION_AUCTION_PRODUCT_NOT_FOUND:
            result = i18n.t('auctions.error.auction-product-not-found');
            break;
        case VALIDATION_AUCTION_PRODUCT_NOT_ACTIVE:
            result = i18n.t('auctions.error.auction-product-not-active');
            break;
        case VALIDATION_AUCTION_IMMUTABLE_PRODUCT:
            result = i18n.t('auctions.error.auction-product-immutable');
            break;
        case VALIDATION_AUCTION_INVALID_DESCRIPTION_LENGTH:
            result = i18n.t('auctions.error.auction-description-invalid-length', { maxLetters: parseInt(params[0], 10) });
            break;
        case VALIDATION_AUCTION_IMMUTABLE_DESCRIPTION:
            result = i18n.t('auctions.error.auction-description-immutable');
            break;
        case VALIDATION_AUCTION_CANNOT_CHANGE_PHASE:
            result = i18n.t('auctions.error.auction-cannot-change-phase', {
                from: i18n.t(`auctions.phase.${getUIPhase(params[0]).id}.name`),
                to: i18n.t(`auctions.phase.${getUIPhase(params[1]).id}.name`),
            });
            break;
        case VALIDATION_AUCTION_PUBLISH_CLOSURE_TIME_NOT_IN_PAST:
            result = i18n.t('auctions.error.auction-closure-time-not-in-past');
            break;
        case VALIDATION_AUCTION_NOT_NULL_SHOW_LAST_PRICE:
            result = i18n.t('auctions.error.auction-show-last-price-not-null');
            break;
        case VALIDATION_AUCTION_EMPTY_SHOW_LAST_PRICE:
            result = i18n.t('auctions.error.auction-show-last-price-empty');
            break;
        case VALIDATION_AUCTION_IMMUTABLE_SHOW_LAST_PRICE:
            result = i18n.t('auctions.error.auction-show-last-price-immutable');
            break;
        case VALIDATION_AUCTION_NOT_NULL_SHOW_RANKING:
            result = i18n.t('auctions.error.auction-show-ranking-not-null');
            break;
        case VALIDATION_AUCTION_EMPTY_SHOW_RANKING:
            result = i18n.t('auctions.error.auction-show-ranking-empty');
            break;
        case VALIDATION_AUCTION_IMMUTABLE_SHOW_RANKING:
            result = i18n.t('auctions.error.auction-show-ranking-immutable');
            break;
        case VALIDATION_AUCTION_NOT_NULL_LIMIT_BID_MODIFICATION:
            result = i18n.t('auctions.error.auction-limit-bid-modification-not-null');
            break;
        case VALIDATION_AUCTION_EMPTY_LIMIT_BID_MODIFICATION:
            result = i18n.t('auctions.error.auction-limit-bid-modification-empty');
            break;
        case VALIDATION_AUCTION_IMMUTABLE_LIMIT_BID_MODIFICATION:
            result = i18n.t('auctions.error.auction-limit-bid-modification-immutable');
            break;
        case VALIDATION_AUCTION_IMMUTABLE_MAX_PRICE:
            result = i18n.t('auctions.error.auction-max-price-immutable');
            break;
        case VALIDATION_AUCTION_IMMUTABLE_MIN_PRICE:
            result = i18n.t('auctions.error.auction-min-price-immutable');
            break;
        case VALIDATION_AUCTION_EMPTY_ZONE:
            result = i18n.t('auctions.error.auction-zone-empty');
            break;
        case VALIDATION_AUCTION_INVALID_ZONE:
            result = i18n.t('auctions.error.auction-zone-invalid');
            break;
        case VALIDATION_AUCTION_IMMUTABLE_ZONE:
            result = i18n.t('auctions.error.auction-zone-immutable');
            break;
        case VALIDATION_AUCTION_EMPTY_AUCTIONEER:
            result = i18n.t('auctions.error.auction-auctioneer-empty');
            break;
        case VALIDATION_AUCTION_INVALID_AUCTIONEER:
            result = i18n.t('auctions.error.auction-auctioneer-invalid');
            break;
        case VALIDATION_AUCTION_IMMUTABLE_AUCTIONEER:
            result = i18n.t('auctions.error.auction-auctioneer-immutable');
            break;
        case VALIDATION_AUCTION_EMPTY_ALGORITHM:
            result = i18n.t('auctions.error.auction-algorithm-empty');
            break;
        case VALIDATION_AUCTION_INVALID_ALGORITHM:
            result = i18n.t('auctions.error.auction-algorithm-invalid');
            break;
        case VALIDATION_AUCTION_IMMUTABLE_ALGORITHM:
            result = i18n.t('auctions.error.auction-algorithm-immutable');
            break;
        case VALIDATION_AUCTION_EMPTY_SMALLEST_UNIT:
            result = i18n.t('auctions.error.auction-smallest-unit-empty');
            break;
        case VALIDATION_AUCTION_NOT_NULL_SMALLEST_UNIT:
            result = i18n.t('auctions.error.auction-smallest-unit-not-null');
            break;
        case VALIDATION_AUCTION_INVALID_SMALLEST_UNIT:
            result = i18n.t('auctions.error.auction-smallest-unit-invalid');
            break;
        case VALIDATION_AUCTION_IMMUTABLE_SMALLEST_UNIT:
            result = i18n.t('auctions.error.auction-smallest-unit-immutable');
            break;
        case VALIDATION_AUCTION_EMPTY_SETTL_START_TYPE:
            result = i18n.t('auctions.error.auction-settl-start-type-empty');
            break;
        case VALIDATION_AUCTION_NOT_NULL_SETTL_START_TYPE:
            result = i18n.t('auctions.error.auction-settl-start-type-not-null');
            break;
        case VALIDATION_AUCTION_IMMUTABLE_SETTL_START_TYPE:
            result = i18n.t('auctions.error.auction-settl-start-type-immutable');
            break;
        case VALIDATION_AUCTION_NOT_NULL_MAX_BID_SIZE:
            result = i18n.t('auctions.error.auction-max-bid-size-not-null');
            break;
        case VALIDATION_AUCTION_INVALID_MAX_BID_SIZE:
            result = i18n.t('auctions.error.auction-max-bid-size-invalid');
            break;
        case VALIDATION_AUCTION_IMMUTABLE_MAX_BID_SIZE:
            result = i18n.t('auctions.error.auction-max-bid-size-immutable');
            break;
        case VALIDATION_AUCTION_NOT_NULL_FAST_MARKET:
            result = i18n.t('auctions.error.auction-fast-market-not-null');
            break;
        case VALIDATION_AUCTION_EMPTY_FAST_MARKET:
            result = i18n.t('auctions.error.auction-fast-market-empty');
            break;
        case VALIDATION_AUCTION_IMMUTABLE_FAST_MARKET:
            result = i18n.t('auctions.error.auction-fast-market-immutable');
            break;
        case VALIDATION_AUCTION_EMPTY_BIDDING_TYPE:
            result = i18n.t('auctions.error.auction-bidding-type-empty');
            break;
        case VALIDATION_AUCTION_INVALID_BIDDING_TYPE:
            result = i18n.t('auctions.error.auction-bidding-type-invalid');
            break;
        case VALIDATION_AUCTION_IMMUTABLE_BIDDING_TYPE:
            result = i18n.t('auctions.error.auction-bidding-type-immutable');
            break;
        case VALIDATION_AUCTION_EMPTY_AUCTION_ACCEPTANCE_TYPE:
            result = i18n.t('auctions.error.auction-acceptance-type-empty');
            break;
        case VALIDATION_AUCTION_INVALID_AUCTION_ACCEPTANCE_TYPE:
            result = i18n.t('auctions.error.auction-acceptance-type-invalid');
            break;
        case VALIDATION_AUCTION_IMMUTABLE_AUCTION_ACCEPTANCE_TYPE:
            result = i18n.t('auctions.error.auction-acceptance-type-immutable');
            break;
        case VALIDATION_AUCTION_EMPTY_TRADE_PRICE_CALCULATION_TYPE:
            result = i18n.t('auctions.error.auction-trade-price-calculation-type-empty');
            break;
        case VALIDATION_AUCTION_INVALID_TRADE_PRICE_CALCULATION_TYPE:
            result = i18n.t('auctions.error.auction-trade-price-calculation-type-invalid');
            break;
        case VALIDATION_AUCTION_IMMUTABLE_TRADE_PRICE_CALCULATION_TYPE:
            result = i18n.t('auctions.error.auction-trade-price-calculation-type-immutable');
            break;
        case VALIDATION_AUCTION_EMPTY_AUCTION_TYPE:
            result = i18n.t('auctions.error.auction-type-empty');
            break;
        case VALIDATION_AUCTION_INVALID_AUCTION_TYPE:
            result = i18n.t('auctions.error.auction-type-invalid');
            break;
        case VALIDATION_AUCTION_IMMUTABLE_AUCTION_TYPE:
            result = i18n.t('auctions.error.auction-type-immutable');
            break;
        case VALIDATION_AUCTION_NOT_NULL_AUCTIONEER_DATA_ITEMS:
            result = i18n.t('auctions.error.auction-auctioneer-data-items-not-null');
            break;
        case VALIDATION_AUCTION_EMPTY_AUCTIONEER_DATA_ITEMS:
            result = i18n.t('auctions.error.auction-auctioneer-data-items-empty');
            break;
        case VALIDATION_AUCTION_AUCTIONEER_DATA_QUANTITY_SUM_NOT_EQUAL_AUCTION_QUANTITY:
            result = i18n.t('auctions.error.auction-auctioneer-data-quantity-sum-not-equal-auction-quantity');
            break;
        case VALIDATION_AUCTION_DEVIATION_LIMIT_MISSING:
            result = i18n.t('auctions.error.auction-deviation-limit-missing');
            break;
        case VALIDATION_AUCTION_RELATIVE_DEVIATION_TOO_LOW:
            result = i18n.t('auctions.error.auction-relative-deviation-too-low', { value: parseInt(params[0], 10) });
            break;
        case VALIDATION_AUCTION_RELATIVE_DEVIATION_TOO_HIGH:
            result = i18n.t('auctions.error.auction-relative-deviation-too-high', { value: parseInt(params[0], 10) });
            break;
        case VALIDATION_AUCTION_QUANTITY_NOT_REACHED:
            result = i18n.t('auctions.error.auction-quantity-not-reached');
            break;
        case VALIDATION_AUCTION_REOPEN_INVALID_CLOSURE_TIME:
            result = i18n.t('auctions.error.auction-reopen-invalid-closure-time');
            break;
        case VALIDATION_AUCTION_INVALID_MAX_BID_SIZE_SMALLEST_UNIT_COMBINATION:
            result = i18n.t('auctions.error.auction-invalid-max-bid-size-smallest-unit-combination');
            break;
        case VALIDATION_AUCTION_INVALID_MIN_MAX_PRICE_COMBINATION:
            result = i18n.t('auctions.error.auction-invalid-min-max-price-combination');
            break;
        case VALIDATION_ENERGY_PER_LOT_INVALID_YEAR:
            result = i18n.t('auctions.error.auction-energy-per-lot.invalid-year');
            break;
        case VALIDATION_ENERGY_PER_LOT_INVALID_POWER:
            result = i18n.t('auctions.error.auction-energy-per-lot.invalid-power');
            break;
        case VALIDATION_ENERGY_PER_LOT_PRODUCT_NOT_ACTIVE:
            result = i18n.t('auctions.error.auction-energy-per-lot.product-not-active');
            break;
        case VALIDATION_ENERGY_PER_LOT_PRODUCT_NOT_FOUND:
            result = i18n.t('auctions.error.auction-energy-per-lot.product-not-found');
            break;
        case ERROR_AUCTION_NOT_FOUND:
        case VALIDATION_AUCTION_NOT_FOUND:
            result = i18n.t('auctions.error.auction-not-found');
            break;
        case ERROR_AUCTION_UPDATE_NOT_ALLOWED:
            result = i18n.t('auctions.error.auction-update-not-allowed');
            break;
        case ERROR_AUCTION_INVALID_SORT_KEY:
            result = i18n.t('auctions.error.auction-invalid-sort-key', { sortKey: params[0] });
            break;
        case VALIDATION_AUCTION_INVALID_PHASE:
            result = i18n.t('auctions.error.auction-invalid-phase', params);
            break;
        case VALIDATION_AUCTION_CLOSING_SOON:
            result = i18n.t('auctions.error.auction-closing-soon', params);
            break;
        case VALIDATION_AUCTION_CLOSING:
            result = i18n.t('auctions.error.auction-closing', params);
            break;
        case VALIDATION_AUCTION_REVENUE_SPLIT_TOO_LOW:
            result = i18n.t('auctions.error.auction-revenue-split-too-low', { value: parseInt(params[0]) });
            break;
        case VALIDATION_AUCTION_REVENUE_SPLIT_TOO_HIGH:
            result = i18n.t('auctions.error.auction-revenue-split-too-high', { value: parseInt(params[0]) });
            break;
        case VALIDATION_AUCTION_EMPTY_REVENUE_SPLIT:
            result = i18n.t('auctions.error.auction-revenue-split-empty');
            break;
        case ERROR_AUCTION_DISTRIBUTE_NOT_DISTRIBUTABLE_PHASE:
            result = i18n.t('auctions.error.auction-distribute-not-distributable-phase');
            break;
        case ERROR_AUCTION_DISTRIBUTE_ALREADY_DISTRIBUTED:
            result = i18n.t('auctions.error.auction-distribute-already-distributed');
            break;
        case ERROR_AUCTION_DISTRIBUTE_WRONG_ZONE:
            result = i18n.t('auctions.error.auction-distribute-wrong-zone');
            break;
        case ERROR_AUCTION_DISTRIBUTE_WRONG_PRODUCT:
            result = i18n.t('auctions.error.auction-distribute-wrong-product');
            break;
        case ERROR_AUCTION_DISTRIBUTE_WRONG_AUCTION_TYPE:
            result = i18n.t('auctions.error.auction-distribute-wrong-auction-type');
            break;
        case ERROR_AUCTION_DISTRIBUTE_NOT_UPCOMING:
            result = i18n.t('auctions.error.auction-distribute-not-upcoming');
            break;
        case ERROR_AUCTION_DISTRIBUTE_INVALID_STEP:
            result = i18n.t('auctions.error.auction-distribute-invalid-step');
            break;
        case ERROR_AUCTION_DISTRIBUTE_NO_DISTRIBUTIONS:
            result = i18n.t('auctions.error.auction-distribute-no-distributions');
            break;
        case ERROR_AUCTION_DISTRIBUTE_DUPLICATE_AUCTION:
            result = i18n.t('auctions.error.auction-distribute-duplicate-auction');
            break;
        case ERROR_AUCTION_DISTRIBUTE_INVALID_AUCTIONEER_STEP:
            result = i18n.t('auctions.error.auction-distribute-invalid-auctioneer-step');
            break;
        case ERROR_AUCTION_DISTRIBUTE_AUCTIONEER_SUM_MISMATCH:
            result = i18n.t('auctions.error.auction-distribute-auctioneer-sum-mismatch');
            break;
        case ERROR_AUCTION_DISTRIBUTE_AUCTIONEER_DATA_MISMATCH:
            result = i18n.t('auctions.error.auction-distribute-auctioneer-data-mismatch');
            break;
        case ERROR_AUCTION_DISTRIBUTE_SOURCE_INDIVISIBLE:
            result = i18n.t('auctions.error.auction-distribute-source-indivisible');
            break;
        case ERROR_AUCTION_DISTRIBUTE_TOTAL_MISMATCH:
            result = i18n.t('auctions.error.auction-distribute-total-mismatch');
            break;
        case ERROR_AUCTION_DISTRIBUTE_AUCTIONEER_ALLOCATION_MISMATCH:
            result = i18n.t('auctions.error.auction-distribute-auctioneer-allocation-mismatch');
            break;
        default:
            result = undefined;
    }
    return result;
};
